export default "__VITE_ASSET__DCMP2fZw__"